/**
 * Linter disallows object instance prototype methods like someObject.hasOwnProperty(key),
 * but we can use this instead.
 *
 * @param {object} object
 * @param {String} key
 * @returns {Boolean}
 */
export default function hasOwnProperty(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}